module.exports = __webpack_public_path__ + "static/media/git.3a4564a9.png";